<template>
	<div>
		<ModalStockistBank ref="ModalStockistBank" @save="saveBank"></ModalStockistBank>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Data Stockist</div>
		</div>
		<v-card class="mt-3 mb-3" outlined>
			<v-list color="deep-purple lighten-5" dark class="pa-3">
				<v-list-item dense class="px-1">
					<v-spacer></v-spacer>
					<v-btn text depressed class="primary mr-2" @click="exportData">
						<v-icon>mdi-export</v-icon>
						<div class="pl-2 text-capitalize">Export</div>
					</v-btn>
					<v-btn depressed class="primary" @click="dropfilter = !dropfilter">
						<v-icon>mdi-filter</v-icon>
						<div class="pl-2">Filter</div>
					</v-btn>
				</v-list-item>
			</v-list>
		</v-card>
		<v-slide-y-transition>
			<v-card outlined class="mb-3" v-if="dropfilter">
				<filterComponent v-if="dropfilter" @searchFilter="searchFilter" @onResetFilter="onResetFilter"></filterComponent>
			</v-card>
		</v-slide-y-transition>
		<v-card outlined >
			<v-data-table loading disable-pagination :headers="headers" :items="listStockist" :search="search" hide-default-footer :options.sync="option" :server-items-length="paginationStockist.total_data" class="table-w-140">
				<template v-slot:item.action="{ item }">
					<v-btn class="" dark small depressed color="indigo" @click.stop="detailBank(item.stockist_network_id)">
						Bank
					</v-btn>
				</template>
				<template v-slot:item.stockist_courier_arr="{ item }">
					<span v-if="item.stockist_courier_arr">{{ item.stockist_courier_arr.map((el) => el.code).toString(', ') }}</span>
				</template>
				<template v-slot:item.stockist_is_active="{ item }">
					{{ item.stockist_is_active == 1 ? 'Aktif' : 'Tidak Aktif' }}
				</template>
				<template v-slot:item.stockist_close_status="{ item }">
					{{ item.stockist_close_status == 'open' ? 'Buka' : 'Tutup' }}
				</template>
				<template v-slot:progress>
					<div>
					</div>
				</template>
				<template v-slot:loading>
					<div class="py-3" v-if="!paginationStockist">
						<loading-data></loading-data>
					</div>
					<div class="py-3" v-else>
						<not-found></not-found>
					</div>
				</template>
			</v-data-table>
		</v-card>
		<div class="pt-5" v-if="paginationStockist">
			<v-row>
				<v-col cols="11" md="11" class="py-0 d-flex justify-space-between">
					<span>Total {{paginationStockist.total_data | toNumber}} Data</span>
					<v-pagination v-model="page" :length="paginationStockist.total_page" @input="changePage" total-visible="7" circle class="d-flex justify-end"></v-pagination>
				</v-col>
				<v-col cols="1" md="1" class="py-0 pl-0">
					<v-autocomplete :items="listLimit" v-model="limit" @input="changeLimit" hide-details class="mt-0" label="Item"></v-autocomplete>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex'
import filterComponent from '@/components/Filter'
import ModalStockistBank from './components/ModalStockistBank'

const list_status = [{
	value: 1,
	text: 'Aktif'
}, {
	value: 0,
	text: 'Tidak Aktif'
}];

export default {
	inject: ['theme'],
	components: {
		filterComponent, ModalStockistBank
	},
	data() {
		return {
			sortBy: 'stockist_network_id',
			sortDir: 'DESC',
			page: 1,
			limit: "10",
			listLimit: [ '5', '10', '20', '50', '100' ],
			dropfilter: false,
			search: '',
			headers: [
			{ text: 'Aksi', align: 'start', value: 'action'},
			{ text: 'Kode Member', align: 'start', value: 'stockist_network_mid'},
			{ text: 'Kode Stockist', align: 'start', value: 'stockist_code'},
			{ text: 'Nama Stockist', value: 'stockist_name'},
			{ text: 'Email Stockist', value: 'stockist_email', sortable: false },
			{ text: 'No. Handphone', value: 'stockist_mobilephone'},
			{ text: 'Jumlah Order', value: 'stockist_order_count'},
			{ text: 'Kurir', value: 'stockist_courier_arr'},
			{ text: 'Status Toko', value: 'stockist_close_status'},
			{ text: 'Status', value: 'stockist_is_active', sortable: false },
			],
			params:[],
			isLoading: false,
			filterData: [{
				type: 'text',
				label: 'Kode Member',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'stockist_network_mid'
				}
			}, {
				type: 'text',
				label: 'Kode Stockist',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'stockist_code'
				}
			}, {
				type: 'text',
				label: 'Nama Stockist',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'stockist_name'
				}
			}, {
				type: 'text',
				label: 'No. Handphone',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'stockist_mobilephone'
				}
			}, {
				type: 'text',
				label: 'Email Stockist',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'stockist_email'
				}
			}, {
				type: 'selection',
				label: 'Status Stockist',
				item: list_status,
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'stockist_is_active'
				}
			}, 
			],
		}
	},
	computed: {
		...mapState(['filterParams']),
		...mapState('ecommerceStockist', ['listStockist', 'paginationStockist']),
	},
	methods: {
		...mapActions('ecommerceStockist', ['getStockist', 'exportStockist', 'getStockistBank', 'saveStockistBank']),
		...mapActions('ecommerceCommon', ['getOptionBank']),
		...mapMutations(['setFilter']),
		...mapMutations('ecommerceStockist', ['clearDataStockist']),

		getData() {
			this.getStockist(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		async detailBank(id) {
			let dataBank = await this.getStockistBank({
				id: id
			})
			await this.$refs.ModalStockistBank.defineParams(dataBank)
			await this.$refs.ModalStockistBank.showModal()
		},
		exportData() {
			this.exportStockist(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		searchFilter(data) {
			this.params = data
			this.getData()
		},
		async onResetFilter() {
			this.params = []
			this.getData()
		},
		async saveBank(data) {
			await this.saveStockistBank(data)
			await this.$refs.ModalStockistBank.hideModal()
		}
	},
	beforeDestroy(){
		this.clearDataStockist()
	},
	watch: {
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'ASC' : 'DESC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		}
	},
	async created() {
		await this.$store.dispatch('setPageTitle', `Stockist Ecommerce`)
		await this.getData()
		await this.getOptionBank()

		await this.setFilter(this.filterData)
	},
};
</script>

<style>
